import httpRequest from '@/infra/httpRequest';
import GetCompanyDTO from '@/application/dto/admin/companies/GetCompanyDTO';

export default class CompaniesRepository {
    public async getAll(): Promise<GetCompanyDTO[]> {
        try {
            const { data: { companies } } = await httpRequest.get(`/admin/companies`);

            return companies.map((company: any) => new GetCompanyDTO(
                company.id,
                company.cnpj,
                company.name
            ))
        } catch (err) {
            throw Error;
        }
    }
}